export const BorderColors = {
  borderColors: {
    borderPrimary100: "#FFFFFF",
    borderPrimary200: "#CCCCCC",
    borderPrimary300: "#999999",
    borderPrimary400: "#666666",
    borderPrimary500: "#4D4D4D",
    borderPrimary700: "#CCCCCC",
    borderPrimary800: "#1A1A1A",
    borderPrimary1000: "#FFFFFF",
    borderGold: "#CCCCCC",
  },
};